
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro-profile",
      function () {
        return require("private-next-pages/pro-profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro-profile"])
      });
    }
  